import { useState } from "react";
import InnerLayout from "../../components/layouts/inner-layout";
import CreateEditViewBilling from "../../components/invoice-section/create-edit-view-billing";

const AddBilling = () => {
  const [loading, setLoading] = useState(true);

  return (
    <InnerLayout backBtn={true} title="Add Billing">
      <CreateEditViewBilling
        disabled={false}
        loading={loading}
        setLoading={setLoading}
        page="add"
        // path="/add-bill"
      />
    </InnerLayout>
  );
};

export default AddBilling;
